$(document).ready(function() {

    /* Smart message on shopping cart --- layout fix */
    textWidth = $('.smart-message-title').width();
    $('.smart-message-title').css('width', textWidth + 20);
    $('.smart-message-title').addClass('smart-title-middle');
    $('.smart-message-title').show();


    //login page - inputs
    var loginInputs = $('.AccountTable').find('input[type="text"] , input[type="email"]');
    for (var i = 0; i < loginInputs.length; i++) {
        if ($(loginInputs[i]).val() != '') {
            $(loginInputs[i]).closest('tr').find('.AccountTextCell').addClass('input-focus');
        }
    }
    $(loginInputs).on('focus', function() {
        $(this).closest('tr').find('.AccountTextCell').addClass('input-focus');
    });
    $(loginInputs).focusout(function() {
        if ($(this).val() == '') {
            $(this).closest('tr').find('.AccountTextCell').removeClass('input-focus');
        }

    });

    //slick
    $('.hp-gallery-carousel').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        verticalSwiping: false
    });

    // blog
    $('.new-blog-footer-slide-wrapper').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000
    });

    // site header slide
    $('.header-slide-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000
    });
    // switchable casrousel
    var widthCalculate = $(window).width();
    $(".flexslider").css({
        width: widthCalculate + 'px'
    });
    $(".carousel-switch-wrap").click(function(e) {
        var switchClicked = e.target;
        if (!$(switchClicked).hasClass('activeSwitch')) {
            $(".carousel-switch").toggleClass("activeSwitch");
            $(".flexslider").toggleClass("carousel-height");
        }
    });

    $('.categoryDesc-firstPart').find('span').on('click', function() {
        $('.categoryDesc-secoundPart').fadeIn("slow");
        $(this).fadeOut("slow");
    });

    $('.categoryDesc-secoundPart').find('span').on('click', function() {
        $('.categoryDesc-secoundPart').fadeOut("slow");
        $('.categoryDesc-firstPart').find('span').fadeIn("slow");
    });


    // fixed body on modal
    $('.ProductGlossary').click(function() {
        $('#floatingArticleClose img').addClass('fiximage');
        if (/iphone/i.test(navigator.userAgent.toLowerCase())) {
            $('body').addClass('fixbody');
        } else {
            $('html , body').css("overflow", "hidden");
        }
    });

    $('#floatingArticleClose, .boxOverlay').click(function() {
        $('#floatingArticleClose img').removeClass('fiximage');
        if (/iphone/i.test(navigator.userAgent.toLowerCase())) {
            $('body').removeClass('fixbody');
        } else {
            $('html , body').css("overflow", "");
        }
    });



    var shipPrices = $('.ShoppingCartShippingRadioButtonList').find('b,strong');
    var shipLi = $('.ShoppingCartShippingRadioButtonList').find('li');
    for (var i = 0; i < shipLi.length; i++) {
        $(shipPrices[i]).clone().appendTo(shipLi[i]);
    }

    //   Review Carousel slick
    $('.hp-review-carousel').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $("body").on("contextmenu", "img", function() {
        return false;
    });

    // GA EVENT --- "Filter clear all" button click GA Event
    $(".search-filter-reset").on("click", function() {

        var prodLink = document.location.href;
        var list = prodLink.split("?")[1].split("=")[1].split("&")[0];
        var eventLabel = "clear_all_" + list;

        ga('send', {
            hitType: 'event',
            eventCategory: "category_page",
            eventAction: "click",
            eventLabel: eventLabel
        });

    });

    $(document).on('click', '.sendSurveyBtn', function () {

        // set values
        q1_val = $(".surveyContent .question_1 input[name=question_1]:checked").val();
        q2_val = $(".surveyContent .question_2 input[name=question_2]:checked").val();
        q2_otherIsChecked = $(".question_2 > ul > li").last().find("input").is(":checked");
        q3_val = $(".surveyContent .question_3 textarea").val();

        // set labels
        q1_eventLabel = "survey_q1_" + q1_val;

        if (q2_val == "other") {
            q2_eventLabel =
                "survey_q3_" + $(".question_2 .AnswerOther").val().trim().split(" ").join("_");
        } else {
            q2_eventLabel = "survey_q2_" + q2_val;
        }

        q3_eventLabel = "survey_q4_" + q3_val.trim().split(" ").join("_");

        // validate values
        if (q1_val == undefined || q2_val == undefined) {
            return;
        }
        if (q2_otherIsChecked && $(".question_2 textarea").val().length == 0) {
            return;
        }
        if (q3_val.length == 0) {
            return;
        }

        $(".thank_you_survey_feedback").show();
        $(".thanksOrderSurvey").hide();

        // send GA events
        // survey question 1
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q1_eventLabel
        });

        // survey question 2
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q2_eventLabel
        });

        // survey question 3
        ga("send", {
            hitType: "event",
            eventCategory: "thank_you_page",
            eventAction: "click",
            eventLabel: q3_eventLabel
        });

    });
});